import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";
const urlPackage = "Package";

//* Actulizar tipo de viaje internacional del paquete cliente
//* PUT /api/Package/Client/International/{IdPaquete}/{EsInternacional}
export const updateTipoViajePaqueteCliente = async ({ IdPaquete, EsInternacional }) => {
  return await axios.put(`${APIURL}/${urlPackage}/Client/International/${IdPaquete}/${EsInternacional}`, {
  }, {
    headers: getCabecera(),
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error);
  })
}

//* Actulizar tipo de viaje internacional del paquete proveedor
//* PUT /api/Package/International/{IdPaquete}/{EsInternacional}
export const updateTipoViajePaqueteProveedor = async ({ IdPaquete, EsInternacional }) => {
  return await axios.put(`${APIURL}/${urlPackage}/International/${IdPaquete}/${EsInternacional}`, {
  }, {
    headers: getCabecera(),
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error);
  })
}

export const getPaqueteDestinos = async (IdPaquete) => {
  const response = await axios.get(
    `${APIURL}/${urlPackage}/Destination/${IdPaquete}`,
    {
      headers: getCabecera(),
    }
  );
  return response.data;
};

export const getPaqueteAll = async (Busqueda) => {
  let paquetes = [];
  const response = await axios.get(`${APIURL}/${urlPackage}/find/${Busqueda}`, {
    headers: getCabecera(),
  });
  paquetes = response.data ?? [];
  return await Promise.all(
    paquetes.map(async (paquete) => {
      return {
        ...paquete,
        Destinos: await getPaqueteDestinos(paquete.IdPaquete),
      };
    })
  );
};

export const getPaqueteById = async ({ idPaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/${idPaquete}`, {
    headers: getCabecera(),
  }).then((Response) => {
    return Response.data;
  });
};

export const updatePaquete = async (idPaquete, payload) => {
  const response = await axios.put(
    `${APIURL}/${urlPackage}/${idPaquete}`,
    payload,
    {
      headers: getCabecera(),
    }
  );
  return response.data;
};

export const newPaquete = async (payload) => {
  const response = await axios.post(`${APIURL}/${urlPackage}`, payload, {
    headers: getCabecera(),
  });
  return response.data;
};

export const updateEstatusPaquete = async ({ ClavePaquete, idEstatusPaquete, AdministradoDooddo }) => {
  return await axios.put(`${APIURL}/${urlPackage}/StatusPackage`, {
    ClavePaquete,
    idCatEstatusPaquete: idEstatusPaquete,
    AdministradoDooddo
  }, {
    headers: getCabecera(),
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error);
  })
}

export const updatePaqueteEstatus = async (idPaquete, estatus) => {
  const response = await axios.put(
    `${APIURL}/${urlPackage}/Drop/${idPaquete}/${estatus}`,
    {},
    {
      headers: getCabecera(),
    }
  );
  return response.data;
};

export const newPaqueteOrigen = async (payload) => {
  const response = await axios.post(`${APIURL}/${urlPackage}/Source`, payload, {
    headers: getCabecera(),
  });
  return response.data;
};

export const newPaqueteDestinos = async (payload) => {
  const response = await axios.post(
    `${APIURL}/${urlPackage}/Destination`,
    payload,
    {
      headers: getCabecera(),
    }
  );
  return response.data;
};
export const deletePaqueteDestino = async ({ idPaquete, idCiudad }) => {
  return await axios.delete(
    `${APIURL}/${urlPackage}/Destination/${idPaquete}/${idCiudad}`,
    {
      headers: getCabecera(),
    }
  ).then((Response) => {
    return Response.data;
  })
};
export const newPaqueteVuelo = async ({ payload }) => {
  return await axios.post(
    `${APIURL}/${urlPackage}/Fligth`,
    payload,
    {
      headers: getCabecera(),
    }
  ).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return Error.response.data;
  })
}
/*
* Paquete extra tipo paquete
*/
export const newPaqueteExtraTipo = async ({
  idCatExtra,
  idExtra,
  imagen,
  extencion
}) => {
  return await axios.put(
    `${APIURL}/${urlPackage}/ExtraHistoric`,
    {
      idCatExtra, idExtra, imagen, extencion
    },
    {
      headers: getCabecera(),
    }
  ).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return { status: 500 }
    // return Error.response.data;
  })
}

export const newPaqueteExtra = async ({ payload }) => {
  return await axios.post(
    `${APIURL}/${urlPackage}/Addon`,
    payload,
    {
      headers: getCabecera(),
    }
  ).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return Error.response.data;
  })
}
export const deleteGaleriaPaquete = async ({ clavePaquete, idPaqueteImagen }) => {
  return await axios.delete(
    `${APIURL}/${urlPackage}/Gallery/${clavePaquete}/${idPaqueteImagen}`,
    {
      headers: getCabecera(),
    }
  ).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return Error.response.data;
  })
}
export const getPaqueteGaleria = async ({ clavePaquete, idTipoImagen }) => {
  return await axios.get(
    `${APIURL}/${urlPackage}/Gallery/${clavePaquete}/${idTipoImagen}`,
    {
      headers: getCabecera(),
    }
  ).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return Error.response.data;
  })
}
export const newPaqueteGaleria = async ({ payload }) => {
  return await axios.post(
    `${APIURL}/${urlPackage}/Gallery`,
    payload,
    {
      headers: getCabecera(),
    }).then((Response) => {
      return Response.data;
    }).catch((Error) => {
      return Error.response.data;
    })
}

export const getPaqueteAllImagen = async ({ Busqueda, IsImagen }) => {
  let paquetes = [];
  const response = await axios.get(`${APIURL}/${urlPackage}/Find/Image/${Busqueda}/${IsImagen}`, {
    headers: getCabecera(),
  });
  paquetes = response.data ?? [];
  return await Promise.all(
    paquetes.map(async (paquete) => {
      return {
        ...paquete,
        Destinos: await getPaqueteDestinos(paquete.IdPaquete),
      };
    })
  );
}
export const getReportePaquetesImagen = async ({ Busqueda, IsImagen }) => {
  return await axios.get(`${APIURL}/${urlPackage}/GenerarExcel/Image/${Busqueda}/${IsImagen}`, {
    headers: getCabecera(),
    responseType: 'blob'
  }).then((Response) => {
    return Response;
  }).catch((Error) => {
    return getError(Error);
  })
}

export const getDetallePaqueteReferencia = async ({ Referencia }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Reference/${Referencia}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}

export const putCambiarEstatusPaquete = async ({ IdPaquete, IdEstatusProceso }) => {
  return await axios.put(`${APIURL}/${urlPackage}/ProcessStatus/${IdPaquete}/${IdEstatusProceso}`, {}, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const putCancelarPaqueteAgente = async ({ IdPaquete, IdEstatusProceso }) => {
  return await axios.put(`${APIURL}/${urlPackage}/Cancellation/Agent/${IdPaquete}`, {
    IdEstatusProceso
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const putCambiarFechaViaje = async ({ IdPaquete, FechaViaje }) => {
  return await axios.put(`${APIURL}/${urlPackage}/TravelDate/${IdPaquete}/${FechaViaje}`, {}, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
//TODO: Fecha de viaje cliente editable
export const putCambiarFechaViajeEditable = async ({ IdPaquete, IdBloqueSalida, IdObjeto }) => {
  return await axios.put(`${APIURL}/${urlPackage}/TravelDate/Agent/${IdPaquete}`, {
    IdBloqueSalida,
    IdObjeto
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
//TODO: Fecha de viaje cliente editable
export const putCambiarNumeroMensualidades = async ({ IdPaquete, NumeroPagos }) => {
  return await axios.put(`${APIURL}/${urlPackage}/MonthlypPayment/${IdPaquete}`, {
    NumeroPagos
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
//TODO: Habitaciones
export const getPaqueteHabitacionesReferencia = async ({ Referencia }) => {
  return await axios.get(`${APIURL}/${urlPackage}/HotelRoom/${Referencia}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return {}
    // return getError(Error);
  })
}
export const postPaqueteHabitacionesReferencia = async ({ Referencia, Triple, Doble, Sencilla, Menor, Compartida, Cuadruple }) => {
  return await axios.put(`${APIURL}/${urlPackage}/HotelRoom/${Referencia}`, {
    Triple,
    Doble,
    Sencilla,
    Menor,
    Compartida,
    Cuadruple
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}

//TODO: Cancelaciones
export const getPenalizacionCancelacionPaquete = async ({ IdPaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Penalty/Cancellation/${IdPaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return {}
    // return getError(Error);
  })
}
export const putCancelacionPaquete = async ({ IdPaquete }) => {
  return await axios.put(`${APIURL}/${urlPackage}/Cancellation/Client/${IdPaquete}`, {
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
//TODO: Cambio de fecha
export const putCambioFechaCliente = async ({ IdPaquete, IdBloqueSalida, IdObjeto }) => {
  return await axios.put(`${APIURL}/${urlPackage}/TravelDate/Client/${IdPaquete}`, {
    IdBloqueSalida,
    IdObjeto
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
/**
 * TODO: Metodos consulta paquete disponible cotizacion
*/
//* Obteencion de paquetes disponibles por categoria para el cliente
export const getPaqueteDiponiblesCategoria = async ({ IdCategoria }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Availability/Client/${IdCategoria}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
//* Obteencion de paquetes disponibles por categoria para el administrador
export const getPaqueteDiponiblesCategoriaAdmin = async ({ IdCategoria }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Availability/Administrator/${IdCategoria}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
export const getPaqueteSuplementoDiponibles = async ({ ClavePaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Availability/Supplement/${ClavePaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
//* Metodo para obtener las fechas de viaje disponibles por clave de paquete
export const getPaqueteFechasDiponibles = async ({ ClavePaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/TravelDate/${ClavePaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
//* Metodo para obtener las habitaciones o plazas disponibles por clave de paquete
export const getPlazasDiponiblesClavePaquete = async ({ ClavePaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/TipoPlaza/${ClavePaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}

//* Consulta extras catalogo con comision de uso de servicio
export const getExtrasDisponiblesClavePaqueteComision = async ({ ClavePaquete, idCatExtra }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Extra/Catalog/${ClavePaquete}/${idCatExtra}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
//* Extra/Catalog/Quotation/{ClavePaquete}/{idCatExtra}
//* Metodo para obtener extras disponibles por clave de paquete
export const getExtrasDisponiblesClavePaquete = async ({ ClavePaquete, idCatExtra }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Extra/Catalog/Quotation/${ClavePaquete}/${idCatExtra}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
export const putCambioPaquete = async ({ Referencia, monto_mensual_a_pagar, paquete_contratado, numero_de_items, deal_currency_code, fecha_de_salida, numero_de_mensualidades, amount, numero_de_personas, suplementosEnviados }) => {
  return await axios.put(`${APIURL}/${urlPackage}/Change/${Referencia}`, {
    paquete_contratado,
    numero_de_items,
    hs_ticket_id: "",
    deal_currency_code,
    fecha_de_salida,
    numero_de_mensualidades,
    amount,
    monto_mensual_a_pagar,
    numero_de_personas,
    suplementosEnviados
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const getPenalizacionCambioPaquete = async ({ Referencia, paquete_contratado, deal_currency_code, amount, numero_de_personas, suplementosEnviados }) => {
  return await axios.post(`${APIURL}/${urlPackage}/Penalty/Change`, {
    Referencia,
    paquete_contratado,
    deal_currency_code,
    amount,
    numero_de_personas,
    suplementosEnviados
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const getMontoMensual = async ({ MontoPaquete, FechaViaje }) => {
  return await axios.get(`${APIURL}/${urlPackage}/MonthlyPayments/${MontoPaquete}/${FechaViaje}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
export const getMontoMensualPaquete = async ({ IdPaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/MonthlyPayments/${IdPaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
//* Monto mensul paquete con metodos de pago 
//* MonthlyPayments/Details/{IdPaquete}
export const getMontoMensualPaqueteDetalle = async ({ IdPaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/MonthlyPayments/Details/${IdPaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}

/*
TODO : Cambio grupales
*/
export const putCambioFechaGrupal = async ({ ClaveViaje, IdBloqueSalida, IdObjeto }) => {
  return await axios.put(`${APIURL}/${urlPackage}/TravelDate/Massive/Agent/${ClaveViaje}`, {
    IdBloqueSalida,
    IdObjeto
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}

export const putCambioFechaGrupalMasivoCustom = async ({ ClaveViaje, FechaSalida }) => {
  return await axios.put(`${APIURL}/${urlPackage}/TravelDate/Agent/Custom/Massive/NoPrice/${ClaveViaje}`, {
    FechaSalida
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}

//* Metodo nuevo para aplicar un check in
export const newCheckInPaquete = async ({ idPaquete }) => {
  return await axios.put(`${APIURL}/${urlPackage}/CheckIn/${idPaquete}`, {
  }, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error);
  })
}
//* metodo para consultar el historial de extras contratados por el cliente
//* GET /api/Package/Extra/Hired/Clients/{Referencia}
export const getExtrasHistorialCliente = async ({ Referencia }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Extra/Hired/Clients/${Referencia}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
//TODO: Metodos para las landing page
//* Alta landing paquete (Relacional)
//* POST /api/Package/Landing
export const postLanginPaquete = async ({ ClavePaquete, IdLanding }) => {
  return await axios.post(`${APIURL}/${urlPackage}/Landing`, {
    "ClavePaquete": ClavePaquete,
    "IdLanding": IdLanding
  }, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error)
  })
}
//* elimina landing paquete (Relacional)
//* DELETE /api/Package/Landing/{IdPaqueteLanding}
export const deleteLanginPaquete = async ({ IdPaqueteLanding }) => {
  return await axios.delete(`${APIURL}/${urlPackage}/Landing/${IdPaqueteLanding}`, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error)
  })
}
//* consulta los paquetes asociados a una landing page
//* GET /api/Package/Landing/{IdLanding}
export const getPaqueteLangin = async ({ IdLanding }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Landing/${IdLanding}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data
  }).catch((Error) => {
    return []
    // return getError(Error);
  })
}
// TODO: Metodos para ofertas
//* Metodo para listar oferta paquetepor clavePaquete sin paginado
//* GET Package/Offer/Current/{ClavePaquete}
export const getPaqueteOfertaLista = async ({ clavePaquete }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Offer/Current/${clavePaquete}`, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return {}
  })
}
//* Metodo para obtener ofertas paquete by clavePaquete
//* GET Package/Offer/{ClavePaquete}/{Pagina}/{Registros}
export const getPaqueteOferta = async ({ clavePaquete, pagina, registros }) => {
  return await axios.get(`${APIURL}/${urlPackage}/Offer/${clavePaquete}/${pagina}/${registros}`, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return {}
  })
}
//* Metodo para dar de alta una nueva oferta
//* POST Package/Offer
export const newOfertaPaquete = async ({ clavePaquete, operacion, cantidad, descripcion, fechaInicio, fechaFin }) => {
  return await axios.post(`${APIURL}/${urlPackage}/Offer`, {
    "ClavePaquete": clavePaquete,
    "Operacion": operacion,
    "Cantidad": cantidad,
    "Descripcion": descripcion,
    "FechaInicio": fechaInicio,
    "FechaFin": fechaFin
  }, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return getError(Error)
  })
}
//* Metodo para actulizar una oferta
//* PUT Package/Offer/{IdPaqueteOferta}
export const updateOfertaPaquete = async ({ idPaqueteOferta, clavePaquete, operacion, cantidad, descripcion, fechaInicio, fechaFin, estatus }) => {
  return await axios.put(`${APIURL}/${urlPackage}/Offer/${idPaqueteOferta}`, {
    "ClavePaquete": clavePaquete,
    "Operacion": operacion,
    "Cantidad": cantidad,
    "Descripcion": descripcion,
    "FechaInicio": fechaInicio,
    "FechaFin": fechaFin,
    "Estatus": estatus
  }, {
    headers: getCabecera()
  }).then(Response => {
    return Response.data
  }).catch(Error => {
    return Error
  })
}